export const MONTH = { value: "MONTH", key: "clients.ratePeriodTypes.month" };
export const BILLING_PERIOD = {
  value: "BILLING_PERIOD",
  key: "clients.ratePeriodTypes.billingPeriod",
};

export default [MONTH, BILLING_PERIOD];



// WEBPACK FOOTER //
// ./src/components/dashboard/clients/enums/ratePeriodTypes.js